import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { fieldLabels } from "../../fieldLabels";
import { FieldChangeItemLegalEntity } from "./FieldChangeItemLegalEntity";
import { FieldChangeItemDefault } from "./FieldChangeItemDefault";
import { FieldChangeItemCountry } from "./FieldChangeItemCountry";
import { ApplictionFieldChange, FieldChange } from "../types";
import { FieldChangeItemProps } from "./FieldChangeItemProps";

const useStyles = makeStyles((theme) => ({
  changeDetails: {
    padding: 15,
  },
  actions: {
    textAlign: "right",
  },
  action: {
    display: "inline-block",
    marginLeft: 15,
    marginRight: 15,
    fontSize: "1em",
  },
  actionDivider: {
    display: "inline-block",
    color: theme.palette.primary.main,
  },
  done: {
    visibility: "hidden",
    opacity: 0,
    transition: "visibility 0s 0.3s, opacity 0.3s linear",
  },
}));

export const FieldChangeItem: React.FC<FieldChangeItemProps> = ({
  change,
}) => {
  const classes = useStyles();

  const getChangeItem = (change: FieldChange | ApplictionFieldChange) => {
    switch (change.field) {
      case "otherLegalEntityType":
        return <FieldChangeItemLegalEntity change={change} />;
      case "otherCountryOfRegistration":
        return <FieldChangeItemCountry change={change} />;
      default:
        return <FieldChangeItemDefault change={change} />;
    }
  };
  return (
    <div>
      <h4 data-test="activity-field-title">
        {fieldLabels[change.field as keyof typeof fieldLabels] || "Unknown field"}
      </h4>
      <div className={classes.changeDetails}>
        <Grid container spacing={3}>
          {getChangeItem(change)}
        </Grid>
      </div>
    </div>
  );
};
